var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Checkbox, Dimmer, Divider, Form, Loader, Message, Select } from "semantic-ui-react";
import { postJsonWithAuthn } from "../RequestHelpers";
var StatusEditModal = /** @class */ (function (_super) {
    __extends(StatusEditModal, _super);
    function StatusEditModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onPmtStatusChange = function (event, data) {
            var val = data.value;
            if (typeof val !== 'string') {
                throw new Error("Unexpected status value: " + val);
            }
            _this.setState({
                pmtStatus: val
            });
        };
        _this.onProdStatusChange = function (event, data) {
            var val = data.value;
            if (typeof val !== 'string') {
                throw new Error("Unexpected status value: " + val);
            }
            _this.setState({
                prodStatus: val
            });
        };
        _this.sendEmailToggle = function (event, data) {
            var checked = data.checked === true;
            _this.setState({ sendStatusChangeEmail: checked });
        };
        _this.updateStatuses = function () {
            _this.setState({
                loading: true,
                success: false,
                error: false
            }, function () {
                postJsonWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/statuses", JSON.stringify({
                    pmtStatus: _this.state.pmtStatus,
                    prodStatus: _this.state.prodStatus,
                    sendEmail: _this.state.sendStatusChangeEmail
                }))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't update order status: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            error: false,
            sendStatusChangeEmail: true,
            pmtStatus: props.initialPmtStatus,
            prodStatus: props.initialProdStatus
        };
        return _this;
    }
    StatusEditModal.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Initial payment status: ",
                this.props.initialPmtStatus),
            React.createElement("p", null,
                "Initial production status: ",
                this.props.initialProdStatus),
            React.createElement(Divider, null),
            React.createElement(Dimmer.Dimmable, { as: Form },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                React.createElement(Form.Field, null,
                    React.createElement("label", null, "Payment status"),
                    React.createElement(Select, { value: this.state.pmtStatus, options: this.props.pmtStatusTransitions.map(function (t) {
                            return {
                                value: t.status,
                                text: t.status,
                                icon: (!t.valid) ? 'warning sign' : ''
                            };
                        }), onChange: this.onPmtStatusChange }),
                    this.props.pmtStatusTransitions.find(function (t) { return (!t.valid
                        && t.status === _this.state.pmtStatus
                        // don't show an error on the initial foo -> foo transition
                        && t.status !== _this.props.initialPmtStatus); }) !== undefined
                        && React.createElement(Message, { negative: true },
                            this.props.initialPmtStatus,
                            " \u27A4 ",
                            this.state.pmtStatus,
                            " is not a normal status transition.")),
                React.createElement(Form.Field, null,
                    React.createElement("label", null, "Production status"),
                    React.createElement(Select, { defaultValue: this.props.initialProdStatus, options: this.props.prodStatusTransitions.map(function (t) {
                            return {
                                value: t.status,
                                text: t.status,
                                icon: (!t.valid) ? 'warning sign' : ''
                            };
                        }), onChange: this.onProdStatusChange }),
                    this.props.prodStatusTransitions.find(function (t) { return (!t.valid
                        && t.status === _this.state.prodStatus
                        && t.status !== _this.props.initialProdStatus); }) !== undefined
                        && React.createElement(Message, { negative: true },
                            this.props.initialProdStatus,
                            " \u27A4 ",
                            this.state.prodStatus,
                            " is not a normal status transition.")),
                React.createElement(Form.Field, null,
                    React.createElement(Checkbox, { disabled: this.state.success, label: 'Send Status Change Email To Customer', onChange: this.sendEmailToggle, checked: this.state.sendStatusChangeEmail })),
                this.state.success &&
                    React.createElement(Message, { positive: true }, "Statuses updated."),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "Statuses could not be updated."),
                React.createElement(Button, { disabled: this.state.success, icon: 'save', label: 'Save', labelPosition: 'left', onClick: this.updateStatuses, positive: true })));
    };
    return StatusEditModal;
}(React.PureComponent));
export default StatusEditModal;
//# sourceMappingURL=EditOrderStatuses.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/EditOrderStatuses.js
// module id = 1192
// module chunks = 0